import { DeckAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { TermsOfUseType } from '../../constants/terms-of-use-type';

import BaseController from '../BaseController';

@Controller({ component: 'layout-privacy-profile', fragment: 'profile-privacy' })
class ProfilePrivacyController extends BaseController {

  onDetailClickOfDeckTerms = (nrSeqTermo: number, termType: string): void => {
    this.historyService.push(APPLICATION_ROUTES.TERMS_OF_USE_MODAL, { nrSeqTermo, termType });
  }

  onDetailClickOfPrivacy = (nrSeqAviso: number): void => {
    this.historyService.push(APPLICATION_ROUTES.PRIVACY_MODAL, { nrSeqAviso });
  }

  @OnClick({ target: ['deck-terms', 'deck-term-consent'] })
  onClickCardDeckTermos(event: ClickEvent): void {
    const { nrSeqTermo } = event.value;
    const deckAPI = event.target as DeckAPI;
    let termType = '';
    switch (deckAPI.getAlias()) {
      case 'deck-terms':
        termType = TermsOfUseType.TERM_OF_USE;
        break;
      case 'deck-term-consent':
        termType = TermsOfUseType.TERM_OF_CONSENT;
        break;
      default:
        break;
    }

    this.onDetailClickOfDeckTerms(nrSeqTermo, termType);
  }

  @OnClick({ target: 'deck-privacy' })
  onClickDeckPrivacy(event: ClickEvent): void {
    const { nrSeqTermo } = event.value;

    this.onDetailClickOfPrivacy(nrSeqTermo);
  }
}

export default ProfilePrivacyController;